import React from 'react';
import { Dialog, DialogContent, DialogClose, DialogTitle } from '@/components/ui/dialog';
import { PortfolioItem } from '@/hooks/useProfile';
import { X } from 'lucide-react';
import MobilePortfolioModalContent from './MobilePortfolioModalContent';

interface MobilePortfolioModalProps {
  item: PortfolioItem;
  isOpen: boolean;
  onClose: () => void;
  username: string;
  username_slug: string;
  profile: {
    avatar_url?: string | null;
    profession?: string | null;
  };
}

const MobilePortfolioModal = ({ 
  item, 
  isOpen, 
  onClose, 
  username,
  username_slug,
  profile
}: MobilePortfolioModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={() => onClose()}>      
      <DialogContent aria-describedby={undefined} className="h-full flex flex-col justify-end items-center max-w-none bg-white/20 backdrop-blur-md border-none shadow-none">
        <DialogTitle className="sr-only">{item.title}</DialogTitle>
        {/* Custom centered close button at the top */}
        <div className="">
          <DialogClose className="flex items-center justify-center w-10 h-10 rounded-full bg-white shadow-md hover:bg-gray-50 transition-colors">
            <X size={16} className="text-gray-500" />
            <span className="sr-only">Close</span>
          </DialogClose>
        </div>
        {/* Center card container */}
        <div className="relative w-full max-w-[700px] bg-white rounded-xl overflow-hidden flex flex-col h-[92dvh]">
          <MobilePortfolioModalContent 
            item={item}
            onClose={onClose}
            username={username}
            username_slug={username_slug}
            profile={profile}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MobilePortfolioModal; 